import SliceNames from '@/state/enum';
import { ExposerState } from '@/state/slices/exposer/typings';

const exposerState: ExposerState = {
	[SliceNames.EXPOSER]: {
		store: null,
		components: {},
	},
};

export default exposerState;
